var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google ",
    clipPath: "url(#clip0_146_2505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2263 14.3225C28.2263 13.3708 28.1492 12.414 27.9845 11.4777H14.7793V16.8689H22.3413C22.0275 18.6076 21.0192 20.1457 19.5429 21.1231V24.6212H24.0543C26.7036 22.1828 28.2263 18.5819 28.2263 14.3225Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7803 28.0009C18.5561 28.0009 21.7404 26.7612 24.0605 24.6212L19.549 21.1231C18.2938 21.9771 16.6734 22.4606 14.7854 22.4606C11.133 22.4606 8.0362 19.9965 6.92505 16.6837H2.26953V20.2898C4.64616 25.0173 9.48688 28.0009 14.7803 28.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.91892 16.6837C6.33248 14.9449 6.33248 13.0621 6.91892 11.3234V7.71729H2.26855C0.28288 11.6732 0.28288 16.3339 2.26855 20.2898L6.91892 16.6837Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.7803 5.54127C16.7762 5.51041 18.7053 6.26146 20.1508 7.64012L24.1479 3.64305C21.6169 1.26642 18.2578 -0.0402103 14.7803 0.000943444C9.48687 0.000943444 4.64616 2.98459 2.26953 7.71728L6.91991 11.3234C8.02591 8.00536 11.1279 5.54127 14.7803 5.54127Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_2505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.a3d697012aa26840a2c247093b87ed75.svg";
export { ForwardRef as ReactComponent };